<div class="example-header">
  <button
    mat-icon-button
    class="example-double-arrow"
    (click)="previousClicked('year')"
    aria-label="Año anterior">
    <mat-icon>keyboard_double_arrow_left</mat-icon>
  </button>
  <button mat-icon-button (click)="previousClicked('month')" aria-label="Mes anterior">
    <mat-icon>arrow_left</mat-icon>
  </button>
  <span class="example-header-label so-text-2">{{ periodLabel() }}</span>
  <button mat-icon-button (click)="nextClicked('month')" aria-label="Mes siguiente">
    <mat-icon>arrow_right</mat-icon>
  </button>
  <button
    mat-icon-button
    class="example-double-arrow"
    (click)="nextClicked('year')"
    aria-label="Año siguiente">
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button>
</div>
